import { authApi } from "./axiosInstance";

const token = () => sessionStorage.getItem("accessToken");
const headers = () => ({ Authorization: `Bearer ${token()}` });

// GET /service-roles?serviceKey=<backend accessKey, e.g. "MY_EDUCATION"> — IS_AUTHENTICATED,
// any logged-in user. Backend-complete, seeded (~53 rows across 16 service keys) — see
// PERMISSIONS_IMPLEMENTATION_PLAN.md "Future Phase — Backend-Driven Route Membership".
export const getServiceRoles = (serviceKey) =>
  authApi.get("/service-roles", { params: { serviceKey }, headers: headers() });
